import { VegaCheckbox, VegaFlex } from '@globalpayments/vega-react';

import { UserRole } from '../../../types/users';

interface RoleCheckboxesProps {
  roles: string[];
  onChange: (roles: string[]) => void;
}

/** Edits the optional elevated roles while showing Basic as mandatory. */
const RoleCheckboxes = ({ roles, onChange }: RoleCheckboxesProps) => {
  const updateRole = (role: UserRole, selected: boolean) => {
    const nextRoles = selected ? [...roles, role] : roles.filter((existingRole) => existingRole !== role);
    onChange([...new Set(nextRoles)]);
  };

  return (
    <VegaFlex direction="col" gap="size-8">
      {Object.values(UserRole).map((role) => (
        <VegaCheckbox
          checked={role === UserRole.Basic || roles.includes(role)}
          disabled={role === UserRole.Basic}
          key={role}
          onVegaChange={(event) => updateRole(role, event.detail === true)}>
          {role}
        </VegaCheckbox>
      ))}
    </VegaFlex>
  );
};

export default RoleCheckboxes;
